import { Box } from "@mui/material";

interface ProcessNumberBoxProps {
    value: string | null;
}

export const ProcessNumberBox: React.FC<ProcessNumberBoxProps> = ({ value }) => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                minWidth: 0,
                display: "flex",
                alignItems: "center",
            }}
        >
            <Box
                component="span"
                title={value ?? undefined}
                sx={{
                    display: "block",
                    width: "100%",
                    px: 1,
                    py: 0.25,
                    borderRadius: 1,
                    bgcolor: "background.paper",
                    borderColor: "divider",
                    color: "text.primary",
                    fontWeight: 800,
                    fontSize: "0.9rem",
                    lineHeight: 1.4,
                    letterSpacing: ".02em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {value ?? "—"}
            </Box>
        </Box>
    );
};
